import { get, post } from '@/utils/request1';

export const orderw = (data) => post('orderw/jsq',data); // 计算器